"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletIcon = void 0;
var React = __importStar(require("react"));
require("./WalletIcon.css");
var WalletIcon = function () { return (React.createElement("div", { className: "WalletIcon" },
    React.createElement("svg", { width: "13", height: "13", viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1.95 1C0.87295 1 0 1.92338 0 3.0625V9.9375C0 11.3125 0.65 12 1.95 12H11.05C12.35 12 13 11.3125 13 9.9375V4.4375C13 4.05779 12.7088 3.75 12.35 3.75H11.7V1.6875C11.7 1.30779 11.4088 1 11.05 1H1.95ZM1.95 2.375H10.4V3.75H1.95C1.5912 3.75 1.3 3.44221 1.3 3.0625C1.3 2.68279 1.5912 2.375 1.95 2.375ZM9.75 6.5C10.1088 6.5 10.4 6.80779 10.4 7.1875C10.4 7.56721 10.1088 7.875 9.75 7.875C9.3912 7.875 9.1 7.56721 9.1 7.1875C9.1 6.80779 9.3912 6.5 9.75 6.5Z", fill: "none" })))); };
exports.WalletIcon = WalletIcon;
